import { create } from "zustand";
import { persist } from "zustand/middleware";
import { iniciarSesion } from "./repositorios/apiServer";

const useStore = create(
  persist(
    (set, get) => ({
      productos: [],
      actualizarProductos: (productosNuevos) =>
        set({ productos: productosNuevos }),
      categorias: [],
      usuarios: [],

      carritoProductos: [],

      setUserToken: (tokenUser) => set({ userToken: tokenUser }),

      verificarLogin: async ({ email, pass }) => {
        try {
          console.log("Verificando login para:", email);
          //const userData = await iniciarSesion({ email, pass });

          const userToken = await iniciarSesion({ email, pass });

          if (userToken && userToken.token) {
            console.log("Token de usuario:", userToken.token);
            set({ userToken: userToken.token });
            return true;
          } else {
            console.log("Autenticación fallida");
            return false;
          }

          /*  if (userData && userData._id) {
            console.log("Usuario autenticado:", userData);
            set({ usuarioAutenticado: userData });
            return true;
          } else {
            console.log("Autenticación fallida");
            return false;
          } */
        } catch (error) {
          console.error("Error de autenticación:", error);
          return false;
        }
      },

      actualizarUsuario: (usuarioNuevo) =>
        set((state) => {
          const existeUsuario = state.usuarios.some(
            (u) => u.email === usuarioNuevo.email
          );

          const listaUsuarios = existeUsuario
            ? state.usuarios
            : [...state.usuarios, usuarioNuevo];

          return {
            usuarios: listaUsuarios,
            usuarioAutenticado: usuarioNuevo,
          };
        }),

      cerrarSesion: () => set({ usuarioAutenticado: null }),

      setCarritoProductos: (productos) => set({ carritoProductos: productos }),

      agregarProductoCarrito: (producto) => {
        const carritoActual = get().carritoProductos;
        const index = carritoActual.findIndex(
          (p) => (p._id || p.id) === (producto._id || producto.id)
        );

        if (index !== -1) {
          const nuevosProductos = [...carritoActual];
          nuevosProductos[index] = {
            ...nuevosProductos[index],
            cantidad: (nuevosProductos[index].cantidad || 1) + 1,
          };
          set({ carritoProductos: nuevosProductos });
        } else {
          set({
            carritoProductos: [...carritoActual, { ...producto, cantidad: 1 }],
          });
        }
      },

      eliminarProductoCarrito: (productoId) => {
        const carritoActual = get().carritoProductos;
        const nuevosProductos = carritoActual.filter(
          (p) => (p._id || p.id) !== productoId
        );
        set({ carritoProductos: nuevosProductos });
      },

      actualizarCantidadProducto: (productoId, cantidad) => {
        const carritoActual = get().carritoProductos;
        const nuevosProductos = carritoActual.map((p) => {
          if ((p._id || p.id) === productoId) {
            return { ...p, cantidad };
          }
          return p;
        });
        set({ carritoProductos: nuevosProductos });
      },

      vaciarCarrito: () => set({ carritoProductos: [] }),
    }),
    {
      name: "app-storage",
      getStorage: () => localStorage,
    }
  )
);

export default useStore;
